import { IJsonQueryStreet } from '../../../../api-models/common/json_query';
import { createGeoTagsManager } from '../../utils/createGeoTagsManager';

export const geoStreetTagsManager = createGeoTagsManager<IJsonQueryStreet>({
  jsonQueryKey: 'street',
  labelGetter: ({ geoTags, geoValue }) => geoTags.streets[geoValue.id] || 'Неизвестная улица',
  id: 'geoStreet',
});
